import React, { createContext, useContext, useReducer } from "react";

import navBarReducer, { initialState } from "./navBarReducer";
import Routes from "../../routes";
import UserInfo from "../../UserInfo";

import { ClearAllCodes } from "../../CodesCache";

const NavBarContext = createContext();

const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
};

export const NavBarProvider = ({ children }) => {
    const [state, dispatch] = useReducer(navBarReducer, initialState);

    const getData = () => {
        dispatch({
            type: "INITIALIZE_NAV_BAR",
            payload: {
                instances: UserInfo.instances,
                userData: {
                    instance: UserInfo.instanceId,
                    userId: UserInfo.userId,
                    firstName: UserInfo.firstName,
                    lastName: UserInfo.lastName,
                    isOptedIn: UserInfo.isOptedIn
                }
            },
        });
    };

    const refreshInstance = (instanceId, optedIn) => {
        dispatch({
            type: "UPDATE_USER_DATA",
            payload: {
                instance: instanceId, 
                isOptedIn: optedIn
            },
        });

        UserInfo.setInstanceId(instanceId);
        UserInfo.setIsOptedIn(optedIn);

        // Calling two in a row forces reload if the user is already on the dashboard.  
        // Yea, its hacky, but react-router devs said that this "isn't their problem".  Jerks.
        // this.props.history.push('/');
        ClearAllCodes();
        window.location = '/';
    }

    const changeInstance = async (instanceId) => {
        const response = await fetch(Routes.Account.ChangeInstance(), {
            method: 'POST',
            headers,
            body: JSON.stringify(instanceId)
        });

        // Data wasn't being used, so I am now using it for the isOptedIn flag
        const optedIn = await response.json();

        refreshInstance(instanceId, optedIn);
    };

    return (
        <NavBarContext.Provider
            value={{
                getData,
                changeInstance,
                refreshInstance,
                instances: state.instances,
                userData: state.userData,
                notifications: state.notifications
            }}
        >
            {children}
        </NavBarContext.Provider>
    );
};

const useNavBar = () => {
    return useContext(NavBarContext);
};

export default useNavBar;